import updateEntity from 'app/entity/actions/update';
import store from 'app/store';
import moment from 'moment';
import { PermissionCategory } from 'shared/helpers/acast-plus';
import Episode from '../entity';

export default episodeId => {
  const episode = store.getState().episode.get(episodeId);
  if (!episode) {
    return Promise.reject('Episode not found');
  }
  const { publishDate } = episode;
  const conditions = episode.conditions.map(condition => {
    if (condition.category === PermissionCategory.EXCLUSIVE_CONTENT) {
      return Object.assign(condition, {
        startDate: publishDate,
      });
    }
    if (condition.category === PermissionCategory.EARLY_RELEASE) {
      const dayCount = moment(condition.endDate).diff(condition.startDate, 'days');

      return Object.assign(condition, {
        startDate: publishDate,
        endDate: moment(publishDate)
          .add(dayCount, 'days')
          .toISOString(),
      });
    }
    return condition;
  });

  return updateEntity(
    Episode,
    episode.merge({
      conditions,
    })
  );
};
